import { render, staticRenderFns } from "./RelatorioPersonalizado.vue?vue&type=template&id=0a2bc49c&scoped=true&"
import script from "./RelatorioPersonalizado.vue?vue&type=script&lang=js&"
export * from "./RelatorioPersonalizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bc49c",
  null
  
)

export default component.exports